import { render, staticRenderFns } from "./edit-product-details.vue?vue&type=template&id=3aa1c3f4&scoped=true&"
import script from "./edit-product-details.ts?vue&type=script&lang=ts&"
export * from "./edit-product-details.ts?vue&type=script&lang=ts&"
import style0 from "./edit-product-details.scss?vue&type=style&index=0&id=3aa1c3f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa1c3f4",
  null
  
)

export default component.exports